import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ProblemReframe } from './components/ProblemReframe';
import { HowItWorks } from './components/HowItWorks';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { BuiltForBoth } from './components/BuiltForBoth';
import { BonusPack } from './components/BonusPack';
import { OfferSummary } from './components/OfferSummary';
import { GetStarted } from './components/GetStarted';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen w-full bg-navy-900 font-sans antialiased" data-id="element-0" data-mp="28u5yeo0zj7dd">
      <SiteHeader data-id="element-1" data-mp="28sbe9bxjfjac" />
      <main data-id="element-2" data-mp="23vkwmk634fmt">
        <Hero data-id="element-3" data-mp="23vuq4hqc94x9" />
        <ProblemReframe data-id="element-4" data-mp="23u9u0nodldxa" />
        <HowItWorks data-id="element-5" data-mp="23ut9lxqjzq85" />
        <WhatsInside data-id="element-6" data-mp="23ti864kkyuk7" />
        <LookInside data-id="element-7" data-mp="3ik7ekc2063oj" />
        <BuiltForBoth data-id="element-8" data-mp="3ikqwhsrnks2k" />
        <BonusPack data-id="element-9" data-mp="3ijfv1zlojwem" />
        <OfferSummary data-id="element-10" data-mp="3ihv0wb3a2fha" />
        <GetStarted data-id="element-11" data-mp="3mlawr57iwbsx" />
        <Faq data-id="element-12" data-mp="3mkrbpfmkt7ao" />
        <FinalCta data-id="element-13" data-mp="3mk86mzi0yde2" />
      </main>
      <SiteFooter data-id="element-14" data-mp="3mjga9mglsbmq" />
    </div>;
}